<template>
  <SuggestField v-bind="$attrs" v-on="$listeners" :loader="loadData">
  <template #item="data">
    <v-list-item-content v-if="data.item.bankName" @click="$emit('suggest', data.item)">
      <v-list-item-title v-text="data.item.bankName"></v-list-item-title>
      <v-list-item-subtitle >
        БИК: {{ data.item.bic }} К/С: {{ data.item.corrAccountNumber }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-content v-else>{{ data.item }}</v-list-item-content>
  </template>
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <template v-for="(_, slot) of $slots" v-slot:[slot]>
      <slot :name="slot" />
    </template>
  </SuggestField>
</template>

<script>
import { findDadataBank } from '@/api/dadata';
import SuggestField from './SuggestField';

export default {
  name: 'DadataBankField',
  components: {SuggestField},
  data: () => ({
    loadData: findDadataBank,
  })
};
</script>
